"use client"
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useStore } from "@/stores/appStore"
import Loading from '@/components/Loading';


interface AuthProps extends React.PropsWithChildren {
  autoRedirect?: boolean;
}
export const Auth = ({ children, autoRedirect = true }: AuthProps) => {
  const router = useRouter();
  const {
    user,
    checkLogin,
  } = useStore((state) => ({
    user: state.user,
    checkLogin: state.checkLogin,
    loginLoading: state.loginLoading,
  }));
  const [isLoggedIn, setIsLoggedIn] = useState(!!user);

  useEffect(() => {
    const checkAndRedirect = async () => {
      const isLoggedIn = await checkLogin();
      setIsLoggedIn(isLoggedIn);
      if (!isLoggedIn && autoRedirect) {
        router.push('/login'); // 未登录，重定向到登录页面
      }
    };
    if (!user) {
      checkAndRedirect();
    } else {
      // 已经登录
      setIsLoggedIn(true);
    }
  }, [user, checkLogin, router, autoRedirect]);

  if (!isLoggedIn && autoRedirect) {
    return <Loading mask size="lg" />;
  }

  return children;
};

